import React from 'react';
import ExperimentationZoneProof from '../components/programmes/ExperimentationZoneProof';
import ProgrammeLandingPage from './ProgrammeLandingPage';

const ExperimentationZonePage = () => (
  <ProgrammeLandingPage
    afterContent={<ExperimentationZoneProof />}
    kind="zone"
  />
);

export default ExperimentationZonePage;
